// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { exposeClientBuild } from "./lib/buildInfo"
import "./styles/globals.css"

// Acceptance 4: <html data-bb-build> names the bundle this tab executes.
exposeClientBuild()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
